import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";

import Navbar from "../../../globals/components/Navbar";

export function buildHomeIndemnityDialogProps(home) {
  return {
    indemnityDialogOpen: home.dialogs.indemnityDialogOpen,
    closeIndemnityDialog: home.dialogs.closeIndemnityDialog,
    selectedBondForIndemnity: home.dialogs.selectedBondForIndemnity,
    indemnityOption: home.dialogs.indemnityOption,
    setIndemnityOption: home.dialogs.setIndemnityOption,
    selectedFiles: home.dialogs.selectedFiles,
    isSubmitting: home.dialogs.isSubmitting,
    markingIndemnityBondId: home.indemnity.markingIndemnity,
    validationOpen: home.dialogs.validationOpen,
    setValidationOpen: home.dialogs.setValidationOpen,
    validationResults: home.dialogs.validationResults,
    hasBlockingErrors: home.compliance.hasBlockingErrors,
    hasPiiWarningsOnly: home.compliance.hasPiiWarningsOnly,
    handleMarkIndemnityOffline: home.dialogs.handleMarkIndemnityOffline,
    handleSubmitIndemnityFiles: home.dialogs.handleSubmitIndemnityFiles,
    handleFinalizeIndemnitySubmit: home.dialogs.handleFinalizeIndemnitySubmit,
    isFinalizing: home.dialogs.isFinalizing,
    handleFilesSelected: home.dialogs.handleFilesSelected,
    handleClearFiles: home.dialogs.handleClearFiles,
    handleRemoveFile: home.dialogs.handleRemoveFile,
    handleViewFile: home.dialogs.handleViewFile,
    processingOpen: home.dialogs.processingOpen,
  };
}

/**
 * Shared PG/IU home layout chrome: navbar, dashboard, two-column sections, footer slot.
 */
export default function HomeShellBase({
  loading,
  header,
  dashboard,
  leftColumn,
  rightColumn,
  footer,
  contentSx = { px: 3, py: 2 },
}) {
  if (loading) {
    return (
      <>
        <Navbar />
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress />
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar />
      {header}
      {dashboard}
      <Box sx={contentSx}>
        <Box
          sx={{
            display: { xs: "block", md: "grid" },
            gridTemplateColumns: { md: "1fr 1fr" },
            gap: 2,
          }}
        >
          {leftColumn}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>{rightColumn}</Box>
        </Box>
      </Box>
      {footer}
    </>
  );
}

HomeShellBase.propTypes = {
  loading: PropTypes.bool,
  header: PropTypes.node,
  dashboard: PropTypes.node,
  leftColumn: PropTypes.node,
  rightColumn: PropTypes.node,
  footer: PropTypes.node,
  contentSx: PropTypes.object,
};
